// https://app.growthbook.io/features/pen-7676_v1
export const PROMO_STICKY_FOOTER_FACE_STACK_FLAG_NAME = 'pen-7676_v1'
